import "./style.css";

function HtmlLoading() {
    return (
        <div class="loading">
            <img src="https://c.tenor.com/I6kN-6X7nhAAAAAj/loading-buffering.gif" alt="" />
        </div>
    )
}

export default function Loading() {
    return (
        <HtmlLoading />
    )
}